export const backToTop = () => {
    const backToTopShow = () => {
        if($(window).scrollTop() >= ($(window).height() * .8)) {
            $('.btn-toTop').addClass('show')
        } else {
            $('.btn-toTop').removeClass('show')
        }
    }

    backToTopShow()
    $(window).scroll(() => {
        backToTopShow()
    })
    
    $('.btn-toTop').click(() => {
        $('html, body').animate({scrollTop:0})
        return false
    })
}

export const heightCourseBox = () => {
    if($('.section-certification-course')[0]) {
        const hcb = () => {
            let maxHeight = 0
            const cc = $('.section-certification-course .cols-txt')
    
            cc.each(function() {
                const height = $(this).height()
    
                if (height > maxHeight) {
                    maxHeight = height
                }
            })
    
            cc.height(maxHeight)
            console.log('init')
        }

        hcb()
        $(document).on('facetwp-loaded', () => {
            hcb()
        })
    }
}

export const khTxtExpand = () => {
    if($('.section-2cols-title-txt')[0]) {
        const el = $('.section-2cols-title-txt'),
            elBn = el.find('.btn-expand'),
            elTx = el.find('.txt-expand')

        elBn.click(function(e) {
            e.preventDefault()

            if(elTx.hasClass('open')) {
                elBn.find('span').text('Read more')
                elTx.removeClass('open')
            } else {
                elBn.find('span').text('Read less')
                elTx.addClass('open')
            }
        })
    }
}

export const faqAccordion = () => {
    if($('.section-faq')[0]) {
        $('.faq-content').each(function() {
            const el = $(this)

            el.find('.faq-title').click(() => {
                if(el.hasClass('open')) {
                    el.removeClass('open')
                } else {
                    $('.faq-content').removeClass('open')
                    el.addClass('open')
                }
            })
        })
    }

    if($('.section-faq-toc')[0]) {
        $('.faq-block').each(function() {
            const el = $(this)

            el.find('.faq-header').click(() => {
                if(el.hasClass('open')) {
                    el.removeClass('open')
                } else {
                    $('.faq-block').removeClass('open')
                    el.addClass('open')
                }
            })
        })
    }
}

export const colsListHover = () => {
    if($('.section-custom-cols')[0]) {
        $('.section-custom-cols .card').each(function() {
            const el = $(this)

            el.find('.list:first-of-type').addClass('active')
            el.find('.list').each(function() {
                const eL = $(this)
    
                eL.hover(() => {
                    el.find('.list').removeClass('active')
                    eL.addClass('active')
                })
            })
        })
    }

    if($('.section-2cols-txt-lists')[0]) {
        $('.section-2cols-txt-lists .card').each(function() {
            const el = $(this)

            el.find('.list:first-of-type').addClass('active')
            el.find('.list').each(function() {
                const eL = $(this)
    
                eL.hover(() => {
                    el.find('.list').removeClass('active')
                    eL.addClass('active')
                })
            })
        })
    }
}

export const statsToHero = () => {
    if($('.section-hero-form')[0] && $('.section-stats')[0]) {
        if($(window).width() < 768) {
            $('.section-stats').prependTo($('.section-hero-form .hero-form'))
        }
    }
}

export const filterMobile = () => {
    if($('.btn-filter')[0]) {
        $('.btn-filter').click(() => {
            if($('.col-filters').hasClass('show')) {
                $('.col-filters').removeClass('show')
            } else {
                $('.col-filters').addClass('show')
            }
        })
    }
}

// about page logo section - unused
export const logosExpand = () => {
    if($('.section-logos-grid')[0]) {
        $('.btn-expand').click(function(e) {
            e.preventDefault()

            if($('.logos-row').hasClass('open')) {
                $('.btn-expand').text('View all clients')
                $('.logos-row').removeClass('open')
            } else {
                $('.btn-expand').text('View less')
                $('.logos-row').addClass('open')
            }
        })
    }
}